import React from "react";
import GridSection from "@/partials/sections/Section/GridSection";
import TeamMemberCard from "./components/TeamMemberCard/TeamMemberCard";

export default function TeamMemberDetails({ teamMembers }) {
  return (
    <GridSection extraClass="max-w-full grid-cols-2 lg:grid-cols-4 gap-6 md:gap-5 items-center justify-center  px-2">
      {teamMembers?.map((member) => (
        <TeamMemberCard key={member?._id} member={member} />
      ))}
    </GridSection>
  );
}
